import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '@env'
import { firstValueFrom } from 'rxjs'
import { TenantResponse } from '@models'

@Injectable({ providedIn: 'root' })
export class TenantService {
  constructor(private http: HttpClient) {}

  async getAll(): Promise<TenantResponse[]> {
    const url = `${environment.cms_latam_api.baseUrl}/tenant/tenant/getAll`
    const response = await firstValueFrom(this.http.get<TenantResponse[]>(url))
    return response
  }
}
